<ng-container *ngIf="!isToday(snapshotDate)">
  <div
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #ff9800;
      color: #fff;
      padding: 8px;
      text-align: center;
      z-index: 9999;
    "
  >
    <span class="text-lg font-bold"
      >Time Travel Mode Active —
      {{ snapshotDate.toString() | date: "yyyy-MM-dd" }}</span
    >
  </div>
  <!-- spacer -->
  <div style="margin-top: 40px"></div>
</ng-container>

<!-- <p-menubar [model]="toolbarActions" /> -->
<p-menubar [model]="toolbarActions" class="w-full">
  <ng-template #start>
    <img src="horizontal-logo.png" style="width: 10em" />
  </ng-template>

  <ng-template #item let-item>
    <span>
      <a [routerLink]="item.route" class="p-menubar-item-link">
        <span [class]="item.icon"></span>
        <span class="ml-2">{{ item.label }}</span>
      </a>
    </span>
  </ng-template>

  <ng-template #end>
    <div
      class="snapshot-date-container"
      [ngClass]="{ 'time-machine-active': !isToday(snapshotDate) }"
    >
      <label for="snapshotDate" class="snapshot-date-label">
        <i class="pi pi-calendar"></i>
        Snapshot Date:
      </label>
      <p-datepicker
        inputId="snapshotDate"
        [(ngModel)]="snapshotDate"
        [showIcon]="true"
        dateFormat="yy-mm-dd"
        [showButtonBar]="true"
        [numberOfMonths]="3"
        (ngModelChange)="onSnapshotDateChange($event)"
      ></p-datepicker>
    </div>
  </ng-template>
</p-menubar>
